import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { subjectFromObs } from 'core/rx-js';

import { Router } from '@angular/router';
import { filter, interval, map, Observable, race, Subject, switchMap, take } from 'rxjs';
import { JwtService } from '../../global-services/jwt.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly _destroy = new Subject<void>();

  readonly AUTH_HEADER = 'authorization'

  readonly TIMEOUT = 2;

  readonly jwtSubject = this._jwtService.jwtSubject;

  readonly authHeaderSubject = subjectFromObs({
    observable: this.jwtSubject.pipe(
      map((jwt) => {
        if (!jwt) {
          return ''
        }

        return `Bearer ${jwt}`
      })
    ),
    until: this._destroy,
    initialValue: ''
  })

  get authHeader() {
    return this.authHeaderSubject.value;
  }

  constructor(
    private readonly _jwtService: JwtService,
    private readonly _router: Router
  ) {
  }


  readonly notProtectedEndpoints = [
    'activity/auth/refreshToken',
    'activity/auth/refreshTokenFromCookie',
    'activity/auth/code',
    'activity/auth/otp',
    'activity/auth/sxs',
    'activity/auth/sendOtp',
    'users/oidcLogin',
    '/version',
    'activity/auth/oidcLogin',
    'activity/auth/withoutAuthentication',
    'users/type/getByActivityId',
    'users/auth',
    'users/sso',
    'users/password',
    '.json'
  ]

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const requestUrlMatchesNotProtected = Boolean(this.notProtectedEndpoints.find((endpoint) => request.url.includes(endpoint) || request.url.startsWith('assets')))
    if (requestUrlMatchesNotProtected) {

      return next.handle(request);
    }

    return race(
      this._jwtService.jwtSubject.pipe(filter(Boolean)),
      interval(5 * 1000).pipe(map(() => 'TIMEOUT' as const))
    )
      .pipe(
        take(1),
        switchMap((jwt) => {
          if (jwt === 'TIMEOUT') {
            console.error(new Error('Jwt not present', { cause: 'JWT_NOT_PRESENT' }), request);

            this._router.navigate([''])
            return next.handle(request)
          }

          request = request.clone({
            setHeaders: {
              Authorization: 'Bearer ' + jwt
            }
          })

          return next.handle(request)
        })
      )

  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
